import React, { useEffect, useRef, useState } from 'react'
import {useHistory} from "react-router-dom";
import OAMSider from '../oam-sider'
import CommitRecord from '../components/commit-record/CommoitRecord';
import projectStyles from '../../project/project.module.less'
import {
  message,
  Button,
  Col,
  ConfigProvider,
  Layout,
  Pagination,
  Popconfirm,
  Row,
  Statistic,
  Table,
  Tooltip,
  Select,
  Input,
} from 'antd'
import {
  SyncOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  StopOutlined,
  ClockCircleOutlined,
  LoadingOutlined
} from '@ant-design/icons'
import zhCN from 'antd/lib/locale/zh_CN'
import idataCourseTableStyles from '../../common/global-styles/idatacoding.module.less'
import commitStyle from './index.module.less'
import StatusCard from '../../../component/status-card/status-card'
import TooltipModal from '../../../component/modal/stop-task-modal/TooltipModal'
import BatchTooltipModal from "../../../component/modal/stop-task-modal/BatchTooltipModal";
import DateRangePicker from '../../../component/date-range-picker/DateRangePicker'
const commitData = [
  {
    commit_id:1,
    task_id: '5',
    task_num: '1.2',
    task_name: '使用SparkSession读取出租车数据集',
    task_type: 'SPARK',
    project_name: '个人信用风险评估项目',
    user: '程成成',
    role: 0,
    college: '北信科',
    start_time: '2022-08-11611:46:54',
    finish_time: '2022-08-11611:46:54',
    status: 'running',
    process: '50',
  },
  {
    commit_id:2,
    task_id: '5',
    task_num: '1.2',
    task_name: '使用SparkSession读取出租车数据集',
    task_type: 'SPARK',
    project_name: '个人信用风险评估项目',
    user: '程成成',
    role: 0,
    college: '北信科',
    start_time: '2022-08-11611:46:54',
    finish_time: '2022-08-11611:46:54',
    status: 'running',
    process: '50',
  },
  {
    commit_id:4,
    task_id: '5',
    task_num: '1.2',
    task_name: '使用SparkSession读取出租车数据集',
    task_type: 'SPARK',
    project_name: '个人信用风险评估项目',
    user: '程成成',
    role: 0,
    college: '北信科',
    start_time: '2022-08-11611:46:54',
    finish_time: '2022-08-11611:46:54',
    status: 'running',
    process: '50',
  },
  {
    commit_id:9,
    task_id: '5',
    task_num: '1.2',
    task_name: '使用SparkSession读取出租车数据集',
    task_type: 'SPARK',
    project_name: '个人信用风险评估项目',
    user: '程成成',
    role: 0,
    college: '北信科',
    start_time: '2022-08-11611:46:54',
    finish_time: '2022-08-11611:46:54',
    status: 'running',
    process: '50',
  },
  {
    commit_id:8,
    task_id: '6',
    task_num: '1.2',
    task_name: '使用SparkSession读取出租车数据集',
    task_type: 'SPARK',
    project_name: '个人信用风险评估项目',
    user: '程成成',
    role: 1,
    college: '北信科',
    start_time: '2022-08-11611:46:54',
    finish_time: '2022-08-11611:46:54',
    status: 'success',
    process: '50',
  },
  {
    commit_id:7,
    task_id: '5',
    task_num: '1.2',
    task_name: '使用SparkSession读取出租车数据集',
    task_type: 'SPARK',
    project_name: '个人信用风险评估项目',
    user: '程成成',
    role: 1,
    college: '北信科',
    start_time: '2022-08-11611:46:54',
    finish_time: '2022-08-11611:46:54',
    status: 'failed',
    process: '50',
  },
  {
    commit_id:6,
    task_id: '5',
    task_num: '1.2',
    task_name: '使用SparkSession读取出租车数据集',
    task_type: 'SPARK',
    project_name: '个人信用风险评估项目',
    user: '程成成',
    role: 1,
    college: '北信科',
    start_time: '2022-08-11611:46:54',
    finish_time: '2022-08-11611:46:54',
    status: 'stoped',
    process: '50',
  },
  {
    commit_id:5,
    task_id: '5',
    task_num: '1.2',
    task_name: '使用SparkSession读取出租车数据集',
    task_type: 'SPARK',
    project_name: '个人信用风险评估项目',
    user: '程成成',
    role: 0,
    college: '北信科',
    start_time: '2022-08-11611:46:54',
    finish_time: '2022-08-11611:46:54',
    status: 'queueing',
    process: '50',
  },
  {
    commit_id:10,
    task_id: '5',
    task_num: '1.2',
    task_name: '使用SparkSession读取出租车数据集',
    task_type: 'SPARK',
    project_name: '个人信用风险评估项目',
    user: '程成成',
    role: 0,
    college: '北信科',
    start_time: '2022-08-11611:46:54',
    finish_time: '2022-08-11611:46:54',
    status: 'stoping',
    process: '50',
  },
  {
    commit_id:12,
    task_id: '5',
    task_num: '1.2',
    task_name: '使用SparkSession读取出租车数据集',
    task_type: 'SPARK',
    project_name: '个人信用风险评估项目',
    user: '程成成',
    role: 0,
    college: '北信科',
    start_time: '2022-08-11611:46:54',
    finish_time: '2022-08-11611:46:54',
    status: 'stoping',
    process: '50',
  },
]
const { Search } = Input
const { Option } = Select
export interface Props {}

const selecOptions = [
  {
    label: '全部班级',
    value: 'all',
  },
  {
    label: '22-大数据',
    value: '22-大数据',
  },
  {
    label: '22-大数据',
    value: '21-大数据',
  },
]
export interface Props {}
const OAMCommitRecord: React.FC<Props> = (props) => {
  return (
    <Layout style={{ minHeight: '100vh', backgroundColor: '#f5f6f8;' }}>
      <OAMSider keys={'commit_record'} openKeys={['']}></OAMSider>
      {/*<div>提交记录</div>*/}
      <CommitRecord mode='oam' />
    </Layout>
  )
}

export default OAMCommitRecord
